<template>
  <div class="downloadScreen">
    <MultiImage
      class="downloadScreen-close"
      name="img_close"
      @click="closeScreen()"
    />
    <show-at :breakpoints="{ small: 768 }" breakpoint="small">
      <DownloadItemListMobile :items="items" />
    </show-at>
    <show-at :breakpoints="{ small: 768 }" breakpoint="mediumAndAbove">
      <DownloadItemListDesktop :items="items" />
    </show-at>
  </div>
</template>

<script>
import DownloadItemListDesktop from "./DownloadItemListDesktop";
import DownloadItemListMobile from "./DownloadItemListMobile";
import MultiImage from "@/components/MultiImage";
import { showAt } from "vue-breakpoints";

export default {
  name: "DownloadScreen",
  components: {
    MultiImage,
    DownloadItemListDesktop,
    DownloadItemListMobile,
    showAt,
  },
  props: {
    items: Array,
    closeScreen: Function,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/";
.downloadScreen {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);

  &-close {
    position: absolute;
    top: 80px;
    right: 100px;
    height: 30px;
    width: 30px;
    @include breakpoint(xs) {
      top: 6vw;
      right: 6vw;
      height: 20px;
      width: 20px;
    }
  }
}
</style>
